import * as types from '../constants/ActionTypes'


export default function users(state = [], action) {
	switch (action.type) {
		case types.ADMIN_SAVE_USER:
			return []

		case types.INSERT_USER:
			return [...state, action.payload];

		case types.ADMIN_SET_USERS:
			return action.payload;

		case types.ADMIN_SET_USER:
			return state.map((u) => {
				return u.uid === action.payload.uid ? action.payload : u
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/users.js